import { Fade, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  defaultText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '20em',
  },
}));

const DefaultUnrederedGridMessage = ({ render, children }) => {
  const classes = useStyles();

  return render ? (
    <Fade in={true} timeout={500}>
      <div>{children}</div>
    </Fade>
  ) : (
    <div className={classes.defaultText}>
      <Typography>Utilice los filtros para realizar una búsqueda</Typography>
    </div>
  );
};

export default DefaultUnrederedGridMessage;
